var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSmileyUpset(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 169.244,
    height: 169.244,
    viewBox: "0 0 169.244 169.244",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1860",
    "data-name": "Group 1860",
    transform: "translate(-487.4 -127.378)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5730",
    "data-name": "Path 5730",
    d: "M51.859,191.849A63.968,63.968,0,1,0,98.27,114.2a63.968,63.968,0,0,0-46.411,77.652",
    transform: "matrix(0.996, -0.087, 0.087, 0.996, 442.396, 39.439)",
    fill: "#e4e4e4"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_31",
    "data-name": "Ellipse 31",
    cx: 63.968,
    cy: 63.968,
    r: 63.968,
    transform: "translate(488.219 246.07) rotate(-67.124)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5731",
    "data-name": "Path 5731",
    d: "M96.143,181.656c-.617,5.78,6.282,5.349,10.594,7.074-3.881-18.111-.862-36.654,4.744-54.334C95.526,133.1,97.25,158.113,95.908,169.283c-.1,4.1.022,8.249.235,12.373",
    transform: "matrix(0.996, -0.087, 0.087, 0.996, 442.396, 39.439)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5732",
    "data-name": "Path 5732",
    d: "M119.344,189.485c1.508,3.464,6.164,4.646,9.618,4.124,6.153-.931.965-5.965-.333-9.989a42.3,42.3,0,0,1-1.835-12.937c0-4.972,1.532-10.273,2.039-15.394.165-1.658,1.23-5.379.268-6.844-3.832-5.833-12.726,9.583-13.359,12.228-2.27,9.489-.235,20,3.6,28.812",
    transform: "matrix(0.996, -0.087, 0.087, 0.996, 442.396, 39.439)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5733",
    "data-name": "Path 5733",
    d: "M72.574,10.99C69.037,4.953,62.983-2.026,55.452.55c-6.019,1.788-9.61,6.75-13.817,11.263-8.645,9.337-19.825,4.553-30.05,2.356C5.63,12.932,1.014,18.332,0,23.723",
    transform: "translate(543.889 230.323) rotate(-4)",
    fill: "none",
    stroke: "#231f20",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5734",
    "data-name": "Path 5734",
    d: "M6.178,1.115A3.586,3.586,0,0,0,2.251.255,3.656,3.656,0,0,0,0,3.641",
    transform: "translate(614.901 236.009) rotate(-4)",
    fill: "none",
    stroke: "#231f20",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5735",
    "data-name": "Path 5735",
    d: "M0,1.467A2.911,2.911,0,0,1,3.573.195,5.134,5.134,0,0,1,6.85,3.309",
    transform: "translate(541.431 253.976) rotate(-4)",
    fill: "none",
    stroke: "#231f20",
    strokeWidth: 2
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmileyUpset);
export default __webpack_public_path__ + "static/media/smiley-upset.78ef32bb71951a937624b59d69f56655.svg";
export { ForwardRef as ReactComponent };